import axios from "axios";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { EndPoints } from "../utils/apiEndpoints";
import { refreshTokenApiCall } from "./LoginService";
import { expiredCokkieInDay, StorageItems } from "../utils/storageItems";

const client = axios.create();

client.interceptors.request.use(
  async function (config) {
    let token = Cookies.get(StorageItems.TOKEN);
    const refreshToken = Cookies.get(StorageItems.REFRESHTOKEN);

    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken && decodedToken.exp) {
        const currentDate = dayjs();
        const expiredDate = dayjs.unix(decodedToken.exp);

        if (currentDate.isAfter(expiredDate) && refreshToken) {
          const response = await refreshTokenApiCall(token, refreshToken);
          if (response) {
            Cookies.set(StorageItems.TOKEN, response.token, {
              expires: expiredCokkieInDay,
            });
            token = response.token;
          } else {
            Cookies.remove(StorageItems.TOKEN);
            window.location.href = EndPoints.LOGIN;
          }
        }
      }
    } else window.location.href = EndPoints.LOGIN;

    config.headers.Authorization = `Bearer ${token}`;
    config.headers.Token = token;
    return config;
  },
  function (error) {
    console.log("error", error);
    return Promise.reject(error);
  }
);

export default client;
